






























































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class GroupList extends Vue {
  @Prop() private data!: any

  private displayIsViewingSestriction (is_viewing_restriction: boolean) {
    if (is_viewing_restriction) {
      return '非公開'
    } else {
      return '公開'
    }
  }
}
